import Vue from 'vue'
import Vuex from 'vuex'

import { data } from '../shared'

Vue.use(Vuex)

export const createStore = () => {
  return new Vuex.Store({
    state: {
      backgroundUrl: null,
      hotspots: [],
      selectedHotspot: {},
      isPlaying: false,
      status: 'idle',
    },
    mutations: {
      setBackgroundUrl(state, backgroundUrl) {
        state.backgroundUrl = backgroundUrl
      },
      setHotspots(state, hotspots) {
        state.hotspots = hotspots
      },
      selectHotspot(state, specs) {
        state.selectedHotspot = specs
      },
      setVideoState(state, isPlaying) {
        state.isPlaying = !state.isPlaying
      },
      setStatus(state, status) {
        state.status = status
      },
    },
    actions: {
      async loadAllData({ commit }, api) {
        const allData = await data.getAllData(api)
        commit('setBackgroundUrl', allData.backgroundUrl)
        commit('setHotspots', allData.hotspots)
      },
      selectHotspot({ commit }, specs) {
        commit('selectHotspot', specs)
        commit('setStatus', 'enter')
      },
      setStatus({ commit }, status) {
        commit('setStatus', status)
      },
      reset({ commit }) {
        commit('selectHotspot', undefined)
        commit('setStatus', 'idle')
      },
    },
    modules: {},
  })
}
